import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService, ICommonMessage, CoreSaveService, ConfigService } from '@gbs-platform-client/fwk-core'


@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.css']
})
export class LandingpageComponent implements OnInit {
  userId: number;
  displayName: string;
  companyId: number;
  showProfile: boolean;
  showMainLandingPage: boolean;
  currentMenu: string = "Dashboard";
  showModule: string = "";
  resetPassword: boolean = false;
  defaultRowsCount: number;
  Menu_URL:string="";
  department:string;
  designation:string;

  constructor(
    private router: Router, private route: ActivatedRoute,
    private configService: ConfigService,
  ) {
    this.userId = 0; this.displayName = ""; this.companyId = 0; this.showProfile = false; this.showMainLandingPage = true;
    this.designation="";this.department="";
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    var self = this;
    window.onscroll = function () {
      self.stickyHeader();
    };
  }

  stickyHeader(): void {
    let header = document.getElementById("myHeader");
    let sticky = header ? header.offsetTop : 0;

    if (header) {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }
  }

  ngOnInit(): void {
    //localStorage.removeItem('currentUser');
    // const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
    // this.userId = user.UserId;
    // this.displayName = user.DisplayName.substring(1, 0);
    // this.companyId = user.CompanyId;
    const user = JSON.parse(localStorage.getItem('loginUserDetails') || '{}');
    this.userId = user.userid;
    this.displayName = user.employeeName;
    //this.companyId = user.CompanyId;
    this.designation = user.designationName;
    this.department = user.departmentName; 
    this.showModule = "Internal Notes Management";
  }
  logout() {
    //localStorage.removeItem('currentUser');
    //localStorage.removeItem('loginUserDetails');
    //this.router.navigate(['login']);
  }

  showMenu(): void {
    let subMenu: HTMLCollectionOf<Element> = document.getElementsByClassName('sidebar');
    if (subMenu && subMenu[0]) {
      subMenu[0].classList.toggle("show");
    }
  }
  profileClick() {
    this.showProfile = true;
  }

  openMenu(): void {
    this.router.navigate(['landingpage/landing-menu']);
  }
  INMDashboard(){
    this.Menu_URL = "/landingpage/menu/C597B738-1800-4DD5-8534-6AE6A33BCC04/main-menu/DF1B6EDA-ED72-477B-B8A7-3F887D8CD540";
    if (this.Menu_URL && this.Menu_URL !== '') {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([this.Menu_URL]);
    }
  }  
  INMSettings(){
    this.Menu_URL = "/landingpage/menu/C597B738-1800-4DD5-8534-6AE6A33BCC04/main-menu/27DFAED9-F41B-42A1-B4C2-C0791E57F6FB";
    if (this.Menu_URL && this.Menu_URL !== '') {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([this.Menu_URL]);
    }
  }
  INMTransactions(){
    this.Menu_URL = "/landingpage/menu/C597B738-1800-4DD5-8534-6AE6A33BCC04/main-menu/A110C246-609C-4A6D-B98E-2997DFDFBD25";
    if (this.Menu_URL && this.Menu_URL !== '') {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([this.Menu_URL]);
    }
  }
  INMReports(){
    this.Menu_URL = "/landingpage/menu/C597B738-1800-4DD5-8534-6AE6A33BCC04/main-menu/6742054E-A944-4B51-9E31-C2C11235C918";
    if (this.Menu_URL && this.Menu_URL !== '') {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([this.Menu_URL]);
    }
  }

  MMDashboard(){
    this.Menu_URL = "/landingpage/menu/CC95D93E-3CEC-4846-B90E-50D6B5E045BB/main-menu/76470417-AF2A-4DCF-A6AC-FD9B4936D59C";
    if (this.Menu_URL && this.Menu_URL !== '') {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([this.Menu_URL]);
    }
  }  
  MMSettings(){
    this.Menu_URL = "/landingpage/menu/CC95D93E-3CEC-4846-B90E-50D6B5E045BB/main-menu/94BA9A70-164D-41E9-AE72-3C815059558B";
    if (this.Menu_URL && this.Menu_URL !== '') {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([this.Menu_URL]);
    }
  }
  MMTransactions(){
    this.Menu_URL = "/landingpage/menu/CC95D93E-3CEC-4846-B90E-50D6B5E045BB/main-menu/ECD7FB03-03DF-44D6-9164-397D49629088";
    if (this.Menu_URL && this.Menu_URL !== '') {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([this.Menu_URL]);
    }
  }
  MMReports(){
    this.Menu_URL = "/landingpage/menu/CC95D93E-3CEC-4846-B90E-50D6B5E045BB/main-menu/FC5588FC-5E6F-4ABA-809A-9105EB69704F";
    if (this.Menu_URL && this.Menu_URL !== '') {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([this.Menu_URL]);
    }
  } 
  CRDashboard(){
    this.Menu_URL = "/landingpage/menu/A854DE23-210B-46FB-96C8-D9D5DD675511/main-menu/7EE725BB-A6C4-4E80-8A89-326F5BC92890";
    if (this.Menu_URL && this.Menu_URL !== '') {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([this.Menu_URL]);
    }
  }  
  CRSettings(){
    this.Menu_URL = "/landingpage/menu/A854DE23-210B-46FB-96C8-D9D5DD675511/main-menu/FF889591-AAF8-4B69-B3CA-F0F506C3906D";
    if (this.Menu_URL && this.Menu_URL !== '') {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([this.Menu_URL]);
    }
  }
  CRTransactions(){
    this.Menu_URL = "/landingpage/menu/A854DE23-210B-46FB-96C8-D9D5DD675511/main-menu/2CDB77DE-9EC4-4207-BBFA-4F2EDC50150F";
    if (this.Menu_URL && this.Menu_URL !== '') {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([this.Menu_URL]);
    }
  }
  CRReports(){
    this.Menu_URL = "/landingpage/menu/A854DE23-210B-46FB-96C8-D9D5DD675511/main-menu/C7D6AAD1-D56D-46B1-8049-F70BA8F6E7C3";
    if (this.Menu_URL && this.Menu_URL !== '') {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([this.Menu_URL]);
    }
  }
 
  openINM(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['landingpage/menu/C597B738-1800-4DD5-8534-6AE6A33BCC04']);
    this.showMainLandingPage = false;
  }
  openMM(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['landingpage/menu/CC95D93E-3CEC-4846-B90E-50D6B5E045BB']);
    this.showMainLandingPage = false;
  }
  openCR(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['landingpage/menu/A854DE23-210B-46FB-96C8-D9D5DD675511']);
    this.showMainLandingPage = false;
  }
  changePassword(): void {
    {
      this.resetPassword = true;
    }
  }
  closeResetPassword() {
    this.resetPassword = false;
  }
  closeChangePassword(): void {
    this.resetPassword = false;
  }
 
}
